import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=1a1d0bb9"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=1a1d0bb9&prod&lang=css"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=1a1d0bb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports